export default __webpack_public_path__ + "static/media/blank-user.40273514.png";